import React from "react";
import {
  Container,
  Typography,
  Paper,
  Stack,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import "../styles/layout/LandingPage.scss";
import PageIntro from "../components/pageintro";
import SplitDescription from "../components/splitdescription";

const imagesForScrollBanner = [
    "/assets/AdvancedAI/GenerativeAI/education.png",
    "/assets/AdvancedAI/GenerativeAI/realestate.png",
    "/assets/AdvancedAI/GenerativeAI/retail.png",
    "/assets/AdvancedAI/GenerativeAI/finance.png",
    "/assets/AdvancedAI/GenerativeAI/travel.png",
    "/assets/AdvancedAI/GenerativeAI/entertainment.png",
    "/assets/AdvancedAI/GenerativeAI/ecom.png",
    "/assets/AdvancedAI/GenerativeAI/logistic.png",
    "/assets/AdvancedAI/GenerativeAI/healthcare.png",
  ];

const GenerativeAI = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <PageIntro
        bg={"/assets/AdvancedAI/GenerativeAI/background.webp"}
        subheading={"Change what’s possible for your business."}
        heading={"Artificial Intelligence Solutions"}
        desc={
          "Unlock your competitive edge with our custom Artificial Intelligence Solutions and AI Consulting."
        }
      />

      {/* <SplitDescription 
      heading1={"Secure, Enterprise-Grade Generative AI Solutions"}
      content1={`Tecloq offers enterprise-grade generative AI services designed to
            empower your business by democratizing access to cutting-edge AI
            capabilities. Our multimodal Large Language Models (such as GPT-3.5,
            GPT-4) are meticulously developed with a focus on robust data
            governance, adherence to AI policies, and alignment with current
            data strategies, ensuring a solid foundation for your data-driven
            initiatives.
            
            Our seasoned technical experts work closely with your team to
            identify high-impact use cases tailored to your enterprise needs.
            With our secure AI solutions, you can trust in the delivery of
            accurate, explainable, and auditable AI results while keeping your
            proprietary knowledge private.`}
        img1={"/assets/AdvancedAI/GenerativeAI/secure.png"}
        
      
      /> */}
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          margin: { xs: "8% 3%", md: "8% 6% 0 9%" },
          flexDirection: { xs: "column", md: "row" },
          padding: "0 !important",
          height: "auto",
          alignItems: { xs: "center", md: "stretch" },
        }}
      >
        {/* Text Section */}
        <section
          style={{
            flexBasis: "100%", // Take full width on mobile
            maxWidth: "100%", // Full width on mobile
            flexBasis: "60%", // Take 60% on desktop
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "24px", md: "40px" },
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              justifyContent: { xs: "center", md: "flex-start" },
              paddingBottom: "6%",
              width: { xs: "100%", md: "80%" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Secure, Enterprise-Grade Generative AI Solutions
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "normal",
              color: "#000000",
              fontSize: { xs: "14px", md: "25px" },
              width: "100%",
              textAlign: { xs: "center", md: "left" },
              lineHeight: { xs: "150%", md: "140%" },
            }}
          >
            Tecloq offers enterprise-grade generative AI services designed to
            empower your business by democratizing access to cutting-edge AI
            capabilities. Our multimodal Large Language Models (such as GPT-3.5,
            GPT-4) are meticulously developed with a focus on robust data
            governance, adherence to AI policies, and alignment with current
            data strategies, ensuring a solid foundation for your data-driven
            initiatives.
            <br />
            Our seasoned technical experts work closely with your team to
            identify high-impact use cases tailored to your enterprise needs.
            With our secure AI solutions, you can trust in the delivery of
            accurate, explainable, and auditable AI results while keeping your
            proprietary knowledge private.
          </Typography>
        </section>

        {/* Image Section */}
        <section
          style={{
            flexBasis: "100%", // Full width on mobile
            maxWidth: "100%", // Full width on mobile
            flexBasis: "40%", // Take 40% on desktop
            display: "flex",
            alignItems: "center", // Vertically center image
            justifyContent: "center", // Horizontally center image
            paddingTop: "0",
          }}
        >
          <img
            src="/assets/AdvancedAI/GenerativeAI/secure.png"
            alt="ourgoal"
            style={{
              height: "auto",
              width: "100%",
              maxWidth: "400px", // Limit image size on large screens
              margin: "0 auto",
              paddingTop: "0",
            }}
            loading="lazy"
          />
        </section>
      </Paper>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "10%", md: "6%" }, // Increase margin on mobile for better spacing
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "3%", md: "1%" }, // More padding on mobile for better separation
            textAlign: "center",
          }}
        >
          Our GenAI Offerings
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "2% 5%", md: "1% 15% 2% 15%" }, // Reduce margins on mobile for better fit
            textAlign: "center",
          }}
        >
          Choosing tecloq as your Data Analytics Services partner means
          embracing a holistic approach to data-driven decision-making. We stand
          out for several reasons.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          flexWrap: "wrap",
          gap: { xs: "5%", md: "3%" },
          marginTop: "5%",
        }}
      >
        {[
          {
            title: "Assistants",
            description:
              "Our AI assistants are designed to augment human capabilities and enhance productivity across various tasks and workflows. These intelligent copilots help to:",
            points: [
              "Reduce administrative burdens by automating repetitive tasks",
              "Enhance decision-making by providing real-time access to relevant data",
              "Improve communication and collaboration across teams and departments",
            ],
          },
          {
            title: "Workflows",
            description:
              "Our AI-powered workflow solutions streamline complex business processes, driving efficiency, agility, and innovation across your organization. These intelligent systems help to:",
            points: [
              "Automate end-to-end workflows, from data collection and analysis to task execution and reporting",
              "Optimize resource allocation based on demand, priorities, and business objectives",
              "Anticipate future trends, risks, and opportunities with AI-driven predictive analytics",
            ],
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              alignContent: "center",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#7F0055",
              width: { xs: "90%", sm: "80%", md: "600px" },
              height: { xs: "auto", md: "525px" }, // Fixed height on desktop, auto on mobile
              margin: { xs: "5%", md: "0" }, // Add margin on mobile for better spacing
            }}
          >
            {/* Title */}
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: { xs: "28px", md: "45px" },
                fontWeight: "700",
                color: "#FFFFFF",
                letterSpacing: "2%",
                display: "flex",
                justifyContent: "center",
                padding: "7% 7% 2% 7%",
              }}
            >
              {item.title}
            </Typography>

            {/* Description */}
            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                lineHeight: "auto",
                padding: "2% 7% 2% 7%",
                textAlign: "left",
                color: "#FFFFFF",
                fontSize: { xs: "16px", md: "20px" },
              }}
            >
              {item.description}
            </Typography>

            {/* Bullet Points */}
            <ul
              style={{
                margin: "0",
                padding: "2% 7% 2% 12%",
                textAlign: "left",
                color: "#FFFFFF",
                fontSize: "16px",
                fontFamily: "Inter",
                lineHeight: "150%",
              }}
            >
              {item.points.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          </Paper>
        ))}
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "6%",
          padding: { xs: "0 5%", md: "0" }, // Adjust side padding for mobile
        }}
      >
        {/* Heading */}
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Smaller font size on mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center", // Ensure center alignment on all screen sizes
          }}
        >
          Progressive business leaders are making GenAI a priority
        </Typography>

        {/* Subheading */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" }, // Responsive font size
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "3% 5% 2% 5%", md: "3% 15% 2% 15%" }, // Adjust margins for mobile
            textAlign: "center",
            lineHeight: { xs: "140%", md: "150%" }, // Adjust line height for readability
          }}
        >
          Choosing tecloq as your Data Analytics Services partner means
          embracing a holistic approach to data-driven decision-making. We stand
          out for several reasons.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignContent: { xs: "center" },
          flexWrap: "wrap",
          gap: "3%",
          marginTop: "2%",
        }}
      >
        {[
          {
            value: "86%",
            description:
              "of IT leaders expect GenAI to play a pivotal role in their organizations soon",
          },
          {
            value: "57%",
            description:
              "of IT decision-makers believe GenAI to be a game-changer",
          },
          {
            value: "71%",
            description:
              "Of marketers expect GenAI to eradicate busy work and allow them to focus more on strategic tasks",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "3%",
              textAlign: "center",
              border: "0.5px solid #FFC3EA",
              alignContent: "center",
              justifyContent: "center",
              boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
              display: "flex",
              flexDirection: "column",
              width: { xs: "60%", sm: "350px" }, // Responsive width
              height: { xs: "auto", sm: "350px" }, // Adjust height on mobile
              padding: { xs: "5% 5%", sm: "0" },
              marginBottom: { xs: "5%" },
            }}
          >
            {/* Percentage */}
            <Typography
              sx={{
                fontFamily: "Orbitron",
                lineHeight: "120%",
                fontSize: { xs: "48px", sm: "95px" }, // Adjust font size for mobile
                fontWeight: "700",
                color: "#F005A2",
                letterSpacing: "2%",
                marginTop: { xs: "5%", sm: "0" },
              }}
            >
              {item.value}
            </Typography>

            {/* Description */}
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: { xs: "16px", sm: "18px" }, // Responsive font size
                padding: { xs: "5%", sm: "10% 15% 3% 15%" }, // Adjust padding for mobile
                textAlign: "center",
                lineHeight: "150%",
                color: "#000",
              }}
            >
              {item.description}
            </Typography>
          </Paper>
        ))}
      </Box>

      {/* Inovative box */}
      <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Column for mobile, row for desktop
    gap: { xs: "24px", md: "5%" },
    margin: { xs: "5% 3%", md: "5% 5% 5% 11%" },
  }}
>
  {/* LEFT SIDE */}
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems:{ xs: "center"},
      width: { xs: "100%", md: "50%" },
      paddingRight: { xs: "0", md: "5%" }, // No padding for mobile
    }}
  >
    <Typography
      sx={{
        fontFamily: "Orbitron",
        lineHeight: "120%",
        fontSize: { xs: "24px", md: "35px" }, // Smaller font for mobile
        fontWeight: "700",
        color: "#000000",
        letterSpacing: "2%",
        textAlign: { xs: "center"}, 
      }}
    >
      Innovate Responsibly and Securely with Insighto.ai
    </Typography>
    <Typography
      sx={{
        fontFamily: "Inter",
        fontSize: { xs: "14px", md: "22px" }, // Smaller font for mobile
        lineHeight: "150%",
        textAlign: "left",
        paddingTop: { xs: "12px", md: "3%" },
        textAlign: { xs: "center"}, // Center text on mobile
      }}
    >
      <a
        href="https://insighto.ai"
        style={{ textDecoration: "underline", color: "#000000" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Insighto.ai
      </a>
      &nbsp;is a powerful platform that offers a streamlined approach to developing cutting-edge LLM applications. It offers access to language models that can be trained on your unique data and fully customized to your specific business needs.  
      <a
        href="https://insighto.ai"
        style={{ textDecoration: "underline", color: "#000000" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Insighto.ai
      </a>
      ’s AI-powered chatbots facilitate multilingual communication, handle diverse data formats (multimodal), and offer deep integration with your existing systems. Here are three key ways  
      <a
        href="https://insighto.ai"
        style={{ textDecoration: "underline", color: "#000000" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Insighto.ai
      </a>
      &nbsp;can revolutionize your business:
    </Typography>
  </Paper>

  {/* RIGHT SIDE */}
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      flexDirection: "column",
      width: { xs: "100%", md: "50%" },
      paddingRight: { xs: "0", md: "5%" }, // Consistent right padding for desktop
    }}
  >
    {/* ITEM 1 */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "4%",
        alignItems: "center",
        paddingBottom: { xs: "12px", md: "16px" },
      }}
    >
      <img
        alt="Customer Support"
        src="/assets/AdvancedAI/GenerativeAI/customersupport.png"
        loading="lazy"
        style={{ width: "28px", height: "28px" }}
      />
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "18px", md: "25px" },
          fontWeight: "700",
          color: "#000000",
          letterSpacing: "1%",
        }}
      >
        Revolutionize Customer Support
      </Typography>
    </Box>
    <Typography
      sx={{
        padding: { xs: "0 0 12px 36px", md: "0 10% 16px 10%" }, // Adjust padding for mobile
        fontSize: { xs: "14px", md: "18px" },
        lineHeight: "150%",
      }}
    >
      Build intelligent chatbots that answer questions, resolve issues, and personalize recommendations, freeing up human support for complex inquiries.
    </Typography>

    {/* ITEM 2 */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "4%",
        alignItems: "center",
        paddingBottom: { xs: "12px", md: "16px" },
      }}
    >
      <img
        alt="HR"
        src="/assets/AdvancedAI/GenerativeAI/hr.png"
        loading="lazy"
        style={{ width: "28px", height: "28px" }}
      />
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "18px", md: "25px" },
          fontWeight: "700",
          color: "#000000",
          letterSpacing: "1%",
        }}
      >
        Streamline HR Processes
      </Typography>
    </Box>
    <Typography
      sx={{
        padding: { xs: "0 0 12px 36px", md: "0 10% 16px 10%" },
        fontSize: { xs: "14px", md: "18px" },
        lineHeight: "150%",
      }}
    >
      Automate routine tasks like answering FAQs, processing paperwork, and scheduling meetings, allowing HR to focus on strategic initiatives and employee engagement.
    </Typography>

    {/* ITEM 3 */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "4%",
        alignItems: "center",
        paddingBottom: { xs: "12px", md: "16px" },
      }}
    >
      <img
        alt="Lead Generation"
        src="/assets/AdvancedAI/GenerativeAI/drive.png"
        loading="lazy"
        style={{ width: "28px", height: "28px" }}
      />
      <Typography
        sx={{
          fontFamily: "Orbitron",
          fontSize: { xs: "18px", md: "25px" },
          fontWeight: "700",
          color: "#000000",
          letterSpacing: "1%",
        }}
      >
        Drive Lead Generation
      </Typography>
    </Box>
    <Typography
      sx={{
        padding: { xs: "0 0 12px 36px", md: "0 10% 16px 10%" },
        fontSize: { xs: "14px", md: "18px" },
        lineHeight: "150%",
      }}
    >
      Create engaging chatbots that capture leads through simple and natural forms and qualify them, converting website visitors into potential customers with real-time information and proactive assistance.
    </Typography>
  </Paper>
</Box>



<Box>
  <Box
    sx={{
      maxWidth: "100% !important",
      height: "auto",
      marginTop: { xs: "12%", md: "6%" }, // Increased margin-top for better spacing on mobile
      paddingX: { xs: "4%", md: "0" }, // Added horizontal padding for mobile
    }}
  >
    {/* Heading */}
    <Typography
      sx={{
        fontFamily: "Orbitron",
        fontWeight: "800",
        fontSize: { xs: "24px", md: "40px" }, // Smaller font size for mobile
        color: "#000000",
        lineHeight: "120%",
        letterSpacing: "2%",
        display: "flex",
        justifyContent: "center",
        paddingBottom: { xs: "2%", md: "1%" },
        textAlign: "center", // Ensure text alignment for both views
      }}
    >
      Leverage Generative AI across Various Industrial Domains
    </Typography>

    {/* Description */}
    <Typography
      sx={{
        fontFamily: "Inter",
        fontWeight: "lighter",
        fontSize: { xs: "14px", md: "20px" }, // Smaller font size for mobile
        color: "#000000",
        display: "flex",
        justifyContent: "center",
        margin: { xs: "4% 5%", md: "3% 15% 2% 15%" }, // Reduced margin for mobile
        textAlign: "center",
        lineHeight: "150%", // Improved readability on mobile
      }}
    >
      As a reputed Generative AI development company, we enable enterprises to
      explore the potential of GenAI across a spectrum of industrial sectors.
    </Typography>
  </Box>
</Box>


<Container
  sx={{
    height: "auto",
    backgroundColor: "#fff",
    maxWidth: "100% !important",
    position: "relative",
    overflow: "hidden",
  }}
>
  <Stack
    className="clientImagCont"
    direction="row"
    spacing={0}
    sx={{
      display: "flex",
      justifyContent: "space-evenly",
      animation: "clientImagCont 20s linear infinite",
      padding: "2% 0 3% 0",
      maxWidth: "100% !important",
      gap: "6%",
    }}
  >
    {[...imagesForScrollBanner, ...imagesForScrollBanner].map((src, index) => (
      <img
        key={index}
        alt=""
        src={src}
        style={{ width: "6%", height: "auto" }}
        loading="lazy"
      />
    ))}
  </Stack>
</Container>

<Box sx={{ background: "#7F0055", maxWidth: "100%", height: { xs: "auto", md: "550px" }, padding: "5% 0" }}>
  <Box sx={{ maxWidth: "100% !important", height: "auto", marginTop: "6%" }}>
    <Typography
      sx={{
        fontFamily: "Orbitron",
        fontWeight: "800",
        fontSize: { xs: "24px", sm: "32px", md: "40px" },
        color: "#FFFFFF",
        lineHeight: "120%",
        letterSpacing: "2%",
        display: "flex",
        justifyContent: "center",
        padding: "4% 5% 2% 5%",
        textAlign: "center",
      }}
    >
      Your Trusted Partner in Generative AI
    </Typography>
    <Typography
      sx={{
        fontFamily: "Inter",
        fontWeight: "lighter",
        fontSize: { xs: "14px", sm: "16px", md: "20px" },
        color: "#FFFFFF",
        display: "flex",
        justifyContent: "center",
        margin: { xs: "2% 5%", md: "1% 15% 2% 15%" },
        textAlign: "center",
      }}
    >
      As a reputed Generative AI development company, we enable enterprises to explore the potential of GenAI across a spectrum of industrial sectors.
    </Typography>
  </Box>

  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: "center",
      justifyContent: "center",
      gap: { xs: "4%", sm: "5%" },
      margin: { xs: "5%", md: "2% 5% 2% 5%" },
    }}
  >
    {[
      {
        title: "Expertise and Experience",
        text: "Benefit from our 10-year expertise in collaborating with both startups and Fortune 500 enterprises within the AI domain. Trust in our proven track record of delivering exceptional results for our clients.",
      },
      {
        title: "Client-Centric Approach",
        text: "Your success is our priority. We prioritize client satisfaction and are committed to providing unparalleled support and service throughout your AI journey.",
      },
      {
        title: "Continuous Innovation",
        text: "In a rapidly evolving technological landscape, we are dedicated to continuous innovation. Stay at the forefront of AI advancements with our cutting-edge solutions.",
      },
    ].map((item, index) => (
      <Card
        key={index}
        sx={{
          width: { xs: "90%", sm: "30%" },
          height: { xs: "auto", md: "15rem" },
          color: "#FFFFFF",
          borderRadius: "16px",
          marginBottom: { xs: "5%", sm: "0" },
        }}
      >
        <CardContent
          sx={{
            height: "5%",
            background: "#F005A2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: "800" }}>
            {item.title}
          </Typography>
        </CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            padding: "5%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "lighter",
              color: "#515151",
              textAlign: "center",
              fontSize: { xs: "14px", sm: "16px" },
            }}
          >
            {item.text}
          </Typography>
        </CardContent>
      </Card>
    ))}
  </Box>
</Box>
{/* <Box sx={{display:"flex", flexDirection:"column", maxWidth:"100%", height:"auto", alignItems: "center"}}>
                <Typography sx={{display:"flex", alignContent:"center", justifyContent:"center",
                    marginTop:"6%", fontFamily:"Orbitron !important", fontSize:"50px", fontWeight:"700",
                    letterSpacing:"2%", lineHeight:"120%"}}>
                    Technologies</Typography>
                <img src='/assets/landingPage/modelImg.png' alt='tech' style=
                {{width:"75%", height:"auto", paddingTop:"3%", paddingBottom:"5%"}}>
                </img>
            </Box> */}
    </Box>
  );
};

export default GenerativeAI;
